import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { NgbDateParserFormatter, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from "./../inspections-scheduled/ngb-date-fr-parser-formatter";
import { environment } from '../../../../../environments/environment';
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-discount-report',
  templateUrl: './discount-report.component.html',
  styleUrls: ['./discount-report.component.scss']
})
export class DiscountReportComponent implements OnInit {
	dtTrigger: Subject<any> = new Subject();
	@Input() count: number;
  	public location = '' ;
  	public old_site; 
	report = {
        branch:'',
        inspector:'',
        start:{},
        end:{},
        dateRange:0
    };
	branches=[];
	inspectors = [];
	inspectorCheck=false;
	user={
      	user_level:'',
    };
    noData=false;
	jobData=false;
	errordetails=false;
	loading=false;

	reportData = [];
	total = [];
  	constructor(
  		private  _router : Router,
  		private calendar: NgbCalendar, 
  		private commonService: CommonService
  	) { }

	ngOnInit() {
		this.old_site = environment.apiSite;
	    this.getBranch();
	    if(localStorage.getItem("user") != null){
	      this.user = (JSON.parse(localStorage.getItem("user")));
	      if(this.user.user_level=='inspector'){
	        this.inspectorCheck=false;
	      }else{
	        this.inspectorCheck=true;
	        this.getInspecotr();
	      }
	    }
	}

	ngOnChanges(){
		if(this.count!=0){
			this.report.dateRange = this.count;
			this.dateRangeSubmit(this.count);
			this.disCountReport();
		}
	}

	disCountReport(){
		if(Object.keys(this.report.start).length == 0 || Object.keys(this.report.end).length == 0){
		  this.errordetails=true;
		  return false;
		}
		this.loading=true;
		this.commonService.getDiscountReport(this.report).subscribe(
		  data => { 
            this.errordetails=false;
            this.loading=false;
            if(data.length<=0){
              this.jobData=false;
              this.noData =true;
            }else{
              this.jobData=true;
              this.noData =false;
              
              this.reportData = data;
              setTimeout(() => {
			      $('.table-sortable').DataTable({
			        paging: false,
			        searching: true,
			        ordering: true,
			        responsive: true,
			        destroy: true
			      });
			   }, 500);
            }
          }
		);
	}

	dateRangeSubmit(value ){
	    this.report.end = this.calendar.getToday();
	    this.report.start =this.commonService.dateRangeSubmit(value);  
	}

	getBranch() {
	    this.commonService.getBranch().subscribe(
	      data => { 
            this.branches = data;
          }
	    );
	}
	getInspecotr(){
	    this.commonService.getInspectors().subscribe(
	      data => { 
            this.inspectors = data;
          }
	    );
	}
	clearReport(){
	    this.report = {
          branch:'',
          inspector:'',
          start:{},
          end:{},
          dateRange:0
        };
	}

}
